export default {
  'footer:link-section:customer-support-phone-number': '{phone}',
  'footer:link-section:widerruf-button': 'Vertrag widerrufen',
  'footer:link-section:widerruf-aria': 'Vertrag widerrufen – Widerrufsformular öffnen',
};
